<template>
    <base-page>
      <el-card style="margin: 5px 0px 5px 0px">
        <el-collapse accordion style="border: none">
          <el-collapse-item name="1" style="border: none">
            <template slot="title">
              <div slot="header" class="clearfix">
                <titlu-pagina
                  Titlu="Raport adaugare produse / deviz"
                />
              </div>
            </template>
        <div class="filtre">
          <el-form @submit.prevent="refresh_info()">
            <el-row style="margin: 10px" class="input-group">   
              <el-col class="input-element">
                <el-form-item label='Interval' size="mini">
                   <el-date-picker   
                       @change="refresh_info"   
                       v-model="Filters.Data"
                       type="daterange"
                       range-separator="-"
                       start-placeholder="Data inceput"
                       end-placeholder="Data sfarsit"
                       :picker-options="datePickerOptions"
                       format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                        />
                   </el-form-item>
             </el-col>
              <el-col  class="input-element" :md="12">
                <el-form-item label='Utilizator' size="mini">
                  <div class="input-group full-width"> 
                    <el-select class='full-width' v-model='Filters.IdUtilizator' filterable @change="refresh_info" clearable>
                        <el-option label='Toti' value='-1'></el-option>
                        <el-option-group key="Activi">
                          <el-option v-for='item in Info.utilizatori' :key="'utilizatori' + item.Id" :label='item.Nume' :value='item.Id' />
                        </el-option-group>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col  class="input-element" :md="12">
                <el-form-item label='Deviz' size="mini">
                  <div class="full-width"> 
                    <el-input class='full-width' v-model='Filters.IdDeviz' @input="deviz_refresh_info" ></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col  class="input-element" :md="12">
                <el-form-item label='Produse' size="mini">
                  <div class="full-width"> 
                    <el-select class='full-width' v-model='Filters.IdProdus' clearable filterable @change="refresh_info" >
                        <el-option label='Toate' value='-1'></el-option>
                        <el-option v-for='item in Info.produse' :key="'produse_' + item.Id" :label='item.Nume' :value='item.Id' />
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col class="input-element" :md="12">
                <el-form-item label='Status' size="mini">
                    <el-select disabled class='full-width' v-model='Filters.Status'>
                        <el-option label='Facturate' value='Facturat'></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>

      <el-table :data="Results" style="width: 100%" id="my-table" >
        <el-table-column type="expand" align="center">
          <template slot-scope="scope">
            <el-table :data="scope.row.Date" border style="width: 96%; margin-left: 4%;" >
              <el-table-column label="Programare">
                <template slot-scope="props">
                    <span v-if="props.row.IdProgramare != '-'">#{{props.row.IdProgramare}}</span>
                    <span v-else>{{props.row.IdProgramare}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="NumeUtilizator" label="Nume utilizator"></el-table-column>
              <el-table-column prop="NumeProdus" label="Nume produs"></el-table-column>
              <el-table-column prop="Cantitate" label="Cantitate" align="right">
                <template slot-scope="props">
                    <span style="color:green" v-if="props.row.Cantitate > 0">{{props.row.Cantitate}}</span>
                    <span style="color:red" v-else>{{props.row.Cantitate}}</span>
                  </template>
              </el-table-column>  
              <el-table-column label="Data">
                <template slot-scope="props">
                    <span>{{formatDateForValue(props.row.Data)}}</span>
                </template>
              </el-table-column> 
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="Deviz">
            <template slot-scope="props">
                <span>#{{props.row.IdDeviz}}</span>
            </template>
        </el-table-column>
        <el-table-column label="Nume client" prop="NumeClient"></el-table-column>
        <el-table-column label="Numar auto" prop="NrAuto"></el-table-column>
       
      </el-table>
      
  
      
  
      <!-- <el-pagination
        @size-change="refresh_info"
        @current-change="refresh_info"
        :page-size.sync="PaginationInfo.PerPage"
        :current-page.sync="PaginationInfo.Page"
        :total="PaginationInfo.RowCount"
        layout="pager"
      /> -->
    </base-page>
  </template>
  
  <script>
  import settings from "@/backend/LocalSettings";
  import BasePage from "@/pages/Admin/BasePage";
  import TitluPagina from "@/widgets/TitluPagina";
  import moment from 'moment';
  
  export default {
    name: "raport_produse",
    extends: BasePage,
    components: {
      "base-page": BasePage,
      "titlu-pagina": TitluPagina,
    },
    data() {
      return {
        datePickerOptions: settings.datePickerOptions,
        Results: [],
        base_url: "",
        Info: {
            utilizatori:[],
            produse:[],
        },
        Filters: {
          IdUtilizator:'-1',
          IdDeviz:'',
          IdProdus:'-1',
          Status:['Facturat'],
          Data: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD 23:59:59')],
        },
        OrderBy: {},
        PaginationInfo: {
          Page: 1,
          PerPage: 50,
          RowCount: 0,
          PageSizes: [10, 25, 50, 100, 200],
        },
        mecNameArray:[],
        inputTimeout:null,
      };
    },
    methods: {
      async get_info() {
        var response = await this.post("receptie/devize/get_info_raport_adaugare_produse_deviz");
        this.Info.utilizatori = response.utilizatori;
        this.Info.produse = response.produse;
        this.refresh_info();
      },

      formatDateForValue(date) {
        date = new Date(date);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      },

      async deviz_refresh_info(){
        try{
            const idInitial =  this.Filters.IdDeviz;
            this.Filters.IdDeviz = this.Filters.IdDeviz.replace(/\D/g, '')
            if (this.inputTimeout) {
                clearTimeout(this.inputTimeout)
            }
            this.inputTimeout = setTimeout(() => {
                if(idInitial != '' && this.Filters.IdDeviz === ''){
                    console.log("nu");
                }else{
                    this.refresh_info();
                }
            }, 500); 
        }catch(error){
            console.error(error)
        }
      },

      async refresh_info() {
        var response = await this.post("receptie/devize/get_raport_adaugare_produse_devize_grupat", {
          Filters: this.Filters,
          OrderBy: this.OrderBy,
        });

        this.Filters.Status = 'Facturat'

        this.Results = response.Results;
      },
  
    },
  
    mounted() {
      this.base_url = settings.BASE_URL;
      this.get_info();
    },
  };
  </script>
  
  <style lang="less" scoped>
  .top50 {
    margin-top: 20px;
  }
  
  .input-group {
    display: flex;
    align-items: flex-start;
    // justify-content: space-between;
  }
  
  .filtre {
    .el-input-number {
      width: 100% !important;
    }
  }
  
  
  
  .total {
    width: 100%;
    background-color: white;
    padding: 14px 10px;
    text-align: end;
    font-size: 18px;
  }
  
  
  .input-element {
    width: 18%;
    margin-right: 2%;
  }
  
  @media only screen and (max-width: 600px) {
    .input-element {
      width: 80%;
      
    }
  
    .phone-btn {
      padding-left: 20px;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
    }
  
    .input-group {
      margin: 10px;
    }
  
    .el-tooltip__popper {
      width: 90%;
    }
  
    .el-date-editor--daterange.el-input__inner {
      width: 300px;
    }
  
    .el-picker-panel__body {
      display: flex;
      flex-direction: column;
    }
  }
  </style>
  